import { memo } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

function Benefits({ colors }) {
  const benefits = [
    {
      icon: <SpeedIcon />,
      title: 'Gain de temps',
      description: 'Divisez par 10 le temps passé sur vos déclarations administratives',
    },
    {
      icon: <SecurityIcon />,
      title: 'Sécurisé',
      description: 'Vos données sont chiffrées et stockées en toute sécurité',
    },
    {
      icon: <SupportAgentIcon />,
      title: 'Support dédié',
      description: 'Une équipe à votre écoute pour vous accompagner',
    },
  ];
  return (
        <Box id="home-benefits" sx={{ py: { xs: 6, md: 10 } }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              mb: 6,
              color: colors.textPrimary,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            Pourquoi choisir Publy Music ?
          </Typography>

          <Grid container spacing={3}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box sx={{ textAlign: 'center' }}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      p: 2,
                      borderRadius: '50%',
                      bgcolor: 'rgba(129,140,248,0.1)',
                      color: colors.primaryLight,
                      mb: 2,
                    }}
                  >
                    {benefit.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      color: colors.textPrimary,
                    }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: colors.textSecondary,
                    }}
                  >
                    {benefit.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

        </Box>
  );
}

export default memo(Benefits);
